import React, { useMemo } from 'react';
import classNames from 'classnames';
import ReportDetails from 'components/ReportDetails';
import {
  REPORT_ACTION_TRANSLATION,
  REPORT_ACTION_ICONS,
  FILE_UPLOAD_FAILED_COPY,
} from '../../utils';
import { DataRoomReport, ERROR_REPORT_ACTIONS } from '../../types';
import { useTranslation } from 'react-i18next';
import RoleTag from 'router/subrouters/DataRoom/subrouters/components/RoleTag';
import {
  roleTagColorMap,
  roleTagLabelMap,
} from 'router/subrouters/DataRoom/constants';
import { MAX_SIZE_COPY } from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/data/DataTypes';

import './ReportLog.styles.scss';
import './ReportLog.styles.responsive.scss';

type ReportLogProps = {
  className?: string;
  report: DataRoomReport;
};

const ReportLog: React.FC<ReportLogProps> = (props) => {
  const { className, report } = props;
  const {
    action,
    createdAt,
    memberRole,
    memberName,
    memberEmail,
    documentName,
    oldDocumentName,
    changedAccessMemberName,
    changedAccessMemberEmail,
    changedAccessMemberRole,
    timeSpent,
    dataRoomQuestion,
    shareableLinkName,
    rfiName,
    memberIpAddress,
    fileUploadErrorCode,
  } = report;

  const { t } = useTranslation();

  const classes = classNames('report-log', className, {
    error: ERROR_REPORT_ACTIONS.includes(action),
  });

  const text = useMemo(
    () =>
      t(REPORT_ACTION_TRANSLATION[action], {
        memberName: memberName || memberEmail,
        memberEmail,
        documentName,
        oldDocumentName,
        changedAccessMemberName:
          changedAccessMemberName || changedAccessMemberEmail,
        changedAccessMemberRole,
        timeSpent,
        questionSubject: dataRoomQuestion?.subject,
        shareableLinkName,
        rfiName,
        memberIpAddress,
        errorType: t(FILE_UPLOAD_FAILED_COPY[fileUploadErrorCode], {
          fileLimit: MAX_SIZE_COPY,
        }),
      }),
    [
      t,
      action,
      memberName,
      memberEmail,
      documentName,
      oldDocumentName,
      changedAccessMemberName,
      changedAccessMemberRole,
      changedAccessMemberEmail,
      timeSpent,
      dataRoomQuestion,
      shareableLinkName,
      rfiName,
      memberIpAddress,
      fileUploadErrorCode,
    ],
  );

  return (
    <ReportDetails
      className={classes}
      text={text}
      createdAt={createdAt}
      icon={REPORT_ACTION_ICONS[action]}
    >
      <div className="report-log__tag">
        <RoleTag variant={roleTagColorMap[memberRole]}>
          {t(roleTagLabelMap[memberRole]) || t('secureLink')}
        </RoleTag>
      </div>
    </ReportDetails>
  );
};

export default ReportLog;
